import React from "react";

export default (props) => {
    const estilos = {
        fontSize: props.fontSize || null,
        borderLeft: props.borderLeft || (props.style && props.style.border),
        borderRight: props.borderRight || (props.style && props.style.border),
        borderBottom: props.borderBottom || (props.style && props.style.border),
        borderTop: props.borderTop || (props.style && props.style.border),
        verticalAlign: props.verticalAlign || "middle",
        minWidth: props.minWidth,
        padding:2,
        width: props.width,
        color: props.color,
        fontWeight: props.fontWeight,
        maxWidth: props.noWrap ? 0 : props.maxWidth,
        overflow: props.noWrap ? "hidden" : null,
        textOverflow: props.noWrap ? "ellipsis" : null,
        whiteSpace: props.noWrap ? "nowrap" : null,
        rowspan: props.rowspan || 1,
        colspan: props.colspan || 1,
        backgroundColor: props.backgroundColor ? props.backgroundColor : props.sticky && "#fff",
    };

    if(props.padding !== undefined) {
        estilos.padding = props.padding;
    } else {
        estilos.paddingBlock = props.paddingBlock || 2;
        estilos.paddingInline = props.paddingInline || 2;
        estilos.paddingLeft = props.paddingLeft || 2;
        estilos.paddingRight = props.paddingRight || 2;
    }

    //stickyTop
    if (props.sticky) {
        estilos.position = "sticky";
        estilos.bottom = -1;
        estilos.boxShadow = "inset 0px 2px 1px 0px rgba(0,0,0,0.20)";
    }

    //stickyLeft
    if (props.stickyFirstColumn) {
        estilos.position = "sticky";
        estilos.left = props.left || 0;
        estilos.boxShadow = "inset 0px 2px 1px 0px rgba(0,0,0,0.20)";
    }

    return (
        <td
            {...props}
            align={props.alignRight ? "right" : props.alignCenter ? "center" : "left"}
            onClick={props.onClick}
            style={{
                ...props.style,
                ...estilos,
            }}
            title={props.title}
        >
            {props.children}
        </td>
    );
};
